import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE = 'theme';

const ThemeService = {
  getList() {
    return Http.get(`/${RESOURCE}/list`);
  }
};

export default ThemeService;
